import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup } from '~/commonComponents';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';

const SuccessIconComponent = () => <AnimatedCheckCircle />;

interface IRejectCandidateSuccessPopupProps {
  professionalName: string;
  onClose: () => void;
}

export const DeclineCandidateSuccessPopup = ({
  onClose,
  professionalName,
}: IRejectCandidateSuccessPopupProps) => (
  // @ts-expect-error - ConfirmPopup still written in JavaScript
  <ConfirmPopup
    Icon={SuccessIconComponent}
    title="Interview Declined"
    titleStyle={{ marginTop: 21, marginBottom: 16 }}
    description={
      <Typography as="span" color={colors.neutral[500]}>
        <Typography as="span" color={colors.neutral[500]}>{professionalName}</Typography> is still an active candidate.
        Invite them
        <br />
        to future interviews from the Candidate page.
      </Typography>
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    rightButtonText="Done"
    rightButtonAction={onClose}
  />
);
